import React from "react";
import { TextOqt, TextPropertyName, WrapperComponent } from "../..";

export const FormNodeSticky = ({fmk}) => {
  return (
    <>
      <WrapperComponent caption="Nombre" Field={<TextPropertyName autoFocus name="nombre" formik={fmk} variant="standard"/>}/>
      <WrapperComponent caption="Anotación" Field={<TextOqt name="anotacion" formik={fmk} variant="standard" multiline={true}/>}/>
    </>
  )
}